import { TEXTOS } from '../../lib/glossario'

/** O bloco das ordens de serviço, agora no glossário. Este arquivo é só o nome curto das telas. */
export const OS = TEXTOS.ordensDeServico
